<div class="yt-card">
  <div class="yt-card__left">
    <div class="yt-card__left__img" (click)="watchVideo()">
      <img [src]="youtubeItem.coverUrl" alt="{{ 'general.coverAlt' | translate }} {{ youtubeItem.title }}" />
      <span class="duration">{{ videoDurationLabel }}</span>
    </div>
  </div>

  <div class="yt-card__right">
    <h3 class="yt-card__right__title" (click)="watchVideo()">{{ youtubeItem.title }}</h3>
    <div class="yt-card__right__views">
      <span
        >{{ youtubeItem.viewCount | number }} {{ 'external.youtube.views' | translate }} - {{ youtubeItem.publishedAt |
        date }}</span
      >
    </div>
    <div class="yt-card__right__channel-info">
      <img class="channel-icon" [src]="youtubeItem.channelCoverUrl" />
      <span>{{ youtubeItem.channelTitle }}</span>
    </div>
    <p class="yt-card__right__description">{{ youtubeItem.description }}</p>
  </div>
</div>
